import { TreeNode } from '../route-builder';

export const HomeModule = { segment: '' } as const satisfies TreeNode;
